export { InternalDiagnostics } from './internal-diagnostics';
